/**
 * 按需引入Element
 * 借助依赖 babel - plugin - component
 * 
 * 安装: 
 *      1. npm install babel - plugin - component - D
 *      2. 修改根目录 .babelrc 或 babel.config.js
 * 文档: 
 *      element-cn.eleme.io/#/zh-CN/component/quickstart
 *      https: //github.com/ElemeFE/element/blob/master/components.json
 */


import Vue from 'vue';
import { 
  Button,
  Radio,
  RadioButton,
  RadioGroup,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Pagination,
} from 'element-ui';

Vue.use(Button)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Pagination)


Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$message = Message;